import PropTypes from 'prop-types';
import React from 'react';

import CustomNavigationLink from '../../../models/CustomNavigationLink';
import Menu from '../../../models/Menu';
import { modelOf } from '../../../prop-types';
import NavigationEntity from '../../../types/NavigationEntity';
import MaybeExternalLink from '../../common/MaybeExternalLink';

const MobileNavigationButtonLink = ({
  child,
  onSelectItem,
  currentPath,
  onClick,
  children,
}) => {
  const type = child.type ? child.type : null;

  if (child.children && child.children.length > 0) {
    return (
      <button
        type="button"
        className="ButtonLink"
        onClick={() => onSelectItem(currentPath)}
      >
        {children}
      </button>
    );
  }

  if (child.onClick) {
    return (
      <button type="button" className="ButtonLink" onClick={child.onClick}>
        {children}
      </button>
    );
  }

  return (
    <MaybeExternalLink
      // So we don't break existing styles
      className="ButtonLink"
      to={child.path}
      type={type}
      onClick={onClick}
      tabIndex={0}
      role="button"
      isNoFollowLink
    >
      {children}
    </MaybeExternalLink>
  );
};

MobileNavigationButtonLink.propTypes = {
  child: PropTypes.oneOfType([
    modelOf(NavigationEntity),
    modelOf(CustomNavigationLink),
    modelOf(Menu),
    /**
     * Fallback to cover static navigation entities,
     * sections and categories,
     * other static objects that has same properties
     */
    PropTypes.object,
  ]).isRequired,
  currentPath: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
  onSelectItem: PropTypes.func.isRequired,
};

export default MobileNavigationButtonLink;
